import React from 'react';

import { SCREENS, useMediaQuery, useT } from '@repo/common';
import PostSection from '../PostSection';
import RichTextarea from './RichTextarea';

const Details = ({ textValues, setTextValues, errors }) => {
  const t = useT();
  const isMobile = useMediaQuery(`(max-width: ${SCREENS.tabletH - 0.02}px)`);
  const minHeight = isMobile ? '120px' : '168px';

  // 에디터(볼드/글머리 기호)는 평문 마크업 문자열을 넘겨준다
  const setFieldValue = (fieldName) => (nextValue) => {
    setTextValues((prev) => ({ ...prev, [fieldName]: nextValue }));
  };

  return (
    <PostSection title={t('Details', '상세 내용')}>
      <RichTextarea
        id='job-post-aboutRole'
        validationField='aboutRole'
        label={t('About the role*', '직무 소개*')}
        placeholder={t(
          'Provide a detailed overview of the role and who would be a great fit',
          '직무에 대한 상세 소개와 어떤 분이 적합한지 작성해 주세요',
        )}
        value={textValues.aboutRole}
        state={errors.aboutRole ? 'failed' : 'default'}
        message={errors.aboutRole}
        onChange={setFieldValue('aboutRole')}
        maxLength={5000}
        minHeight={minHeight}
      />

      <RichTextarea
        id='job-post-jobDescription'
        validationField='jobDescription'
        label={t('Job description*', '상세 업무 내용*')}
        placeholder={t(
          'Outline the key responsibilities and main tasks for this position',
          '이 포지션의 주요 책임과 핵심 업무를 작성해 주세요',
        )}
        value={textValues.jobDescription}
        state={errors.jobDescription ? 'failed' : 'default'}
        message={errors.jobDescription}
        onChange={setFieldValue('jobDescription')}
        maxLength={5000}
        minHeight={minHeight}
      />
    </PostSection>
  );
};

export default Details;
